import React from "react";

function OrderPending() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="25"
      enableBackground="new 0 0 512 512"
      viewBox="0 0 512 512"
    >
      <path
        fill="#ff8f33"
        d="M437.775 177.637v309.04c0 13.987-11.336 25.323-25.323 25.323H30.921c-13.987 0-25.323-11.336-25.323-25.323v-309.04c0-13.987 11.336-25.323 25.323-25.323h381.531c13.987 0 25.323 11.336 25.323 25.323z"
        data-original="#ff8f33"
      ></path>
      <path
        fill="#ffaf40"
        d="M402.593 152.314c-4.069 184.95-155.271 333.637-341.2 333.637-19 0-37.638-1.553-55.795-4.541V177.637c0-13.987 11.336-25.323 25.323-25.323z"
        data-original="#ffaf40"
      ></path>
      <path
        fill="#ffc751"
        d="M349.339 152.314c-4.052 155.55-131.426 280.4-287.946 280.4-19.093 0-37.748-1.857-55.795-5.402V177.637c0-13.987 11.336-25.323 25.323-25.323z"
        data-original="#ffc751"
      ></path>
      <path
        fill="#fff370"
        d="M5.599 275.629v117.144c0 10.563 8.563 19.126 19.126 19.126s19.126-8.563 19.126-19.126V275.629c0-10.563-8.563-19.126-19.126-19.126s-19.126 8.563-19.126 19.126z"
        data-original="#fff370"
      ></path>
      <circle
        cx="24.725"
        cy="216.912"
        r="19.126"
        fill="#fff370"
        data-original="#fff370"
      ></circle>
      <path
        fill="#79ff79"
        d="M120.479 353.435l-19.923-29.413c-3.38-4.99-10.729-4.99-14.109 0l-19.923 29.413c-3.833 5.658.221 13.299 7.055 13.299h39.846c6.833 0 10.886-7.641 7.054-13.299z"
        data-original="#79ff79"
      ></path>
      <path
        fill="#29e088"
        d="M113.424 366.734H97.626a35.795 35.795 0 003.4-15.277c0-11.528-5.419-21.787-13.846-28.374 3.621-4.022 10.225-3.715 13.377.937l19.921 29.413c3.835 5.658-.221 13.301-7.054 13.301z"
        data-original="#29e088"
      ></path>
      <path
        fill="#ac92dd"
        d="M76.111 459.25c-6.113 0-11.069-4.956-11.069-11.069v-47.435c0-6.113 4.956-11.069 11.069-11.069s11.069 4.956 11.069 11.069v47.435c0 6.113-4.956 11.069-11.069 11.069z"
        data-original="#ac92dd"
      ></path>
      <path
        fill="#9566d1"
        d="M76.111 459.25c-6.113 0-11.069-4.956-11.069-11.069v-30.045c0-6.113 4.956-11.069 11.069-11.069s11.069 4.956 11.069 11.069v30.045c0 6.113-4.956 11.069-11.069 11.069z"
        data-original="#9566d1"
      ></path>
      <path
        fill="#ac92dd"
        d="M110.89 441.86c-6.113 0-11.069-4.956-11.069-11.069v-30.045c0-6.113 4.956-11.069 11.069-11.069s11.069 4.956 11.069 11.069v30.045c0 6.113-4.955 11.069-11.069 11.069z"
        data-original="#ac92dd"
      ></path>
      <path
        fill="#9566d1"
        d="M110.89 441.86c-6.113 0-11.069-4.956-11.069-11.069v-12.655c0-6.113 4.956-11.069 11.069-11.069s11.069 4.956 11.069 11.069v12.655c0 6.113-4.955 11.069-11.069 11.069z"
        data-original="#9566d1"
      ></path>
      <path
        fill="#e0006b"
        d="M276.418 152.314v94.657c0 13.987-11.345 25.323-25.323 25.323h-58.817c-12.872 0-23.516-9.614-25.103-22.065a23.036 23.036 0 01-.219-3.258v-94.657z"
        data-original="#e0006b"
      ></path>
      <path
        fill="#fe2582"
        d="M246.765 181.03c0 38.592-31.282 69.874-69.874 69.874-3.3 0-6.542-.228-9.716-.675a23.036 23.036 0 01-.219-3.258v-94.657h73.656c3.95 8.762 6.153 18.477 6.153 28.716z"
        data-original="#fe2582"
      ></path>
      <path
        fill="#fc70b2"
        d="M200.719 152.314v59.424c0 9.327-7.555 16.882-16.882 16.882-9.319 0-16.882-7.555-16.882-16.882v-59.424z"
        data-original="#fc70b2"
      ></path>
      <path
        fill="#a37fdd"
        d="M350.068 24.571h38.033v50.594h-38.033z"
        data-original="#a37fdd"
      ></path>
      <path
        fill="#9566d1"
        d="M388.105 24.574v50.59h-38.032V68.4c13.659-3.277 23.823-15.582 23.823-30.255 0-4.868-1.119-9.473-3.111-13.572h17.32z"
        data-original="#9566d1"
      ></path>
      <circle
        cx="369.084"
        cy="194.718"
        r="137.316"
        fill="#d8d0ef"
        data-original="#d8d0ef"
      ></circle>
      <path
        fill="#c5b4ed"
        d="M506.401 194.717c0 75.841-61.482 137.322-137.322 137.322-28.325 0-54.661-8.584-76.526-23.292a137.825 137.825 0 0019.011 1.315c75.829 0 137.311-61.481 137.311-137.322 0-47.504-24.123-89.368-60.774-114.019 66.841 9.258 118.3 66.616 118.3 135.996z"
        data-original="#c5b4ed"
      ></path>
      <path
        fill="#d8d0ef"
        d="M397.402 31.262h-56.634a8.74 8.74 0 01-8.739-8.739V8.742a8.74 8.74 0 018.739-8.739h56.634a8.74 8.74 0 018.739 8.739v13.781a8.74 8.74 0 01-8.739 8.739z"
        data-original="#d8d0ef"
      ></path>
      <path
        fill="#c5b4ed"
        d="M406.142 8.739V22.52a8.736 8.736 0 01-8.739 8.739H369.01c13.17-4.85 22.896-16.831 24.496-31.26h3.898c4.823.001 8.738 3.916 8.738 8.74z"
        data-original="#c5b4ed"
      ></path>
      <circle
        cx="369.084"
        cy="194.718"
        r="104.443"
        fill="#a37fdd"
        data-original="#a37fdd"
      ></circle>
      <path
        fill="#9566d1"
        d="M473.526 194.715c0 57.682-46.756 104.446-104.438 104.446-43.996 0-81.636-27.201-97.019-65.694 17.696 22.672 45.279 37.242 76.271 37.242 53.428 0 96.734-43.306 96.734-96.735 0-30.984-14.571-58.575-37.234-76.271 38.493 15.392 65.686 53.024 65.686 97.012z"
        data-original="#9566d1"
      ></path>
      <path
        fill="#f1f0f7"
        d="M266.418 175.524c5.846-31.476 25.804-57.995 53.07-72.737 8.066-4.361 10.967-14.512 6.38-22.452l-.167-.289c-4.402-7.618-14.072-10.391-21.812-6.208-35.95 19.43-62.248 54.427-69.861 95.958-1.83 9.984 5.871 19.181 16.022 19.181h.339c7.902 0 14.587-5.686 16.029-13.453z"
        data-original="#f1f0f7"
      ></path>
      <path
        fill="#fe2582"
        d="M398.556 227.24l-35.408-34.916a4.37 4.37 0 01-.466-5.681l47.305-65.06a4.37 4.37 0 016.104-.965l3.535 2.57a4.37 4.37 0 01.965 6.104l-40.672 55.937a4.37 4.37 0 00.466 5.681l27.376 26.996a4.369 4.369 0 01.043 6.179l-3.068 3.111a4.37 4.37 0 01-6.18.044z"
        data-original="#fe2582"
      ></path>
    </svg>
  );
}

export default OrderPending;